import { Suspense } from "react";
import App from "./App";
import Loading from "./components/shared/loading/loading";
import { ContextUserProvider } from "./context/user.context";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 15000 } },
});

function AppWrapper() {
  return (
    <Suspense fallback={<Loading />}>
      <QueryClientProvider client={queryClient}>
        <ContextUserProvider>
          <App />
        </ContextUserProvider>
      </QueryClientProvider>
    </Suspense>
  );
}

export default AppWrapper;
